import { channels, timelineEvents } from "@/mocks/data";

const kindStyle: Record<string, string> = {
  发酵: "bg-primary-500 text-background-50",
  进展: "bg-secondary-500 text-background-50",
  回应: "bg-accent-500 text-foreground-950",
  反转: "bg-foreground-950 text-background-50",
};

export default function TimelineSection() {
  return (
    <section id="timeline" className="scroll-mt-20">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid gap-10 lg:grid-cols-5">
          {/* timeline */}
          <div className="lg:col-span-3">
            <h2 className="flex items-center gap-2 font-heading text-2xl font-black text-foreground-950">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-foreground-950 text-background-50">
                <i className="ri-time-line text-lg" />
              </span>
              事件时间线复盘
            </h2>
            <p className="mt-1 pl-11 text-sm text-foreground-500">
              以「代厨风波」为例，从发酵到回应完整还原关键节点。
            </p>

            <ol className="relative mt-8 ml-2 border-l-2 border-background-300 pl-6 md:ml-3">
              {timelineEvents.map((ev, idx) => (
                <li key={idx} className="relative pb-7 last:pb-0">
                  <span
                    className={`absolute -left-[35px] flex h-6 w-6 items-center justify-center rounded-full text-[11px] font-semibold ring-4 ring-background-50 ${kindStyle[ev.kind]}`}
                  >
                    {idx + 1}
                  </span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-label text-xs font-semibold uppercase tracking-wider text-primary-700">
                      {ev.time}
                    </span>
                    <span
                      className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs ${kindStyle[ev.kind]}`}
                    >
                      {ev.kind}
                    </span>
                  </div>
                  <h3 className="mt-1 font-heading text-base font-bold text-foreground-950">
                    {ev.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">
                    {ev.desc}
                  </p>
                </li>
              ))}
            </ol>
          </div>

          {/* channels */}
          <div className="lg:col-span-2">
            <div className="sticky top-24">
              <div className="flex items-center justify-between">
                <h2 className="flex items-center gap-2 font-heading text-lg font-black text-foreground-950">
                  <i className="ri-apps-2-line text-primary-600" />
                  栏目分布
                </h2>
                <span className="text-xs text-foreground-400">按话题量排序</span>
              </div>
              <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-1">
                {channels.map((c) => (
                  <a
                    key={c.key}
                    href="#latest"
                    className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-0.5 hover:border-primary-200"
                  >
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                      <i className={`${c.icon} text-xl`} />
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block font-medium text-foreground-950">
                        {c.name}
                      </span>
                      <span className="block text-xs text-foreground-500">
                        已跟进 {c.count} 起事件
                      </span>
                    </span>
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                      进入
                      <i className="ri-arrow-right-s-line text-base group-hover:text-primary-600" />
                    </span>
                  </a>
                ))}
              </div>

              <div className="mt-5 rounded-lg border border-background-200 bg-accent-100 p-5">
                <p className="font-heading text-base font-bold text-accent-900">
                  想知道某件事现在怎样了？
                </p>
                <p className="mt-1 text-sm text-accent-800">
                  事件有更新会及时同步到对应栏目与热搜榜，新料、回应、反转都不会漏。
                </p>
                <a
                  href="#faq"
                  className="mt-3 inline-flex whitespace-nowrap items-center gap-1 text-sm font-semibold text-foreground-950 hover:underline"
                >
                  查看跟进规则
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}